export function reduceSynchronized<T, U>(array: T[], worker: (x: T) => Promise<U>, start?: Promise<U>) {
  return array.reduce(function(waitingFor, item) {
    return waitingFor.then(function() {
      return worker(item);
    });
  }, Promise.resolve(start));
}
